// @flow
import React, {useState, useRef, useEffect} from 'react';
import {Overlay, Nav, Button} from 'react-bootstrap';
import {NavLink, useHistory} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {StyledDiv, Badge, LinkText, OuterToggleSideBar} from './mobileSidebar';
import BrowseSidebar from './browseSidebar';
import LocalStorageService from '../../utils/LocalStorageService';
import HomeTutorial from '../../pages/Home/components/HomeTutorial';
import VideoTutorial from '../../pages/Video/components/VideoTutorial';
// import CmeTutorial from '../../pages/CME/Components/CmeTutorial';
import {useStore} from '../../store';
import '@fortawesome/fontawesome-free/css/all.min.css';
import MyVideos from '../../assets/icons/MyVideos.png';
import Videos from '../../assets/icons/UserVideos.png';

const MobileSidebar = observer(() => {
  const {sidebarUIStore, messageStore} = useStore();
  const {show} = sidebarUIStore;
  const {unreadMessage = []} = messageStore || {};
  const location = useHistory();
  const target = useRef(null);
  const loggedInUser = LocalStorageService.getUser();
  const [showHomepageTutorial, setShowHomepageTutorial] = useState(false);
  const [showVideopageTutorial, setShowVideopageTutorial] = useState(false);
  const [showCmepageTutorial, setShowCmepageTutorial] = useState(false);
  const [lockUser, setLockUser] = useState(false);

  const {accountStore} = useStore();
  const {account, setFeaturePermission} = accountStore;

  const ShowTutorial = () => {
    if (location.location.pathname.includes('/video')) {
      setShowVideopageTutorial(!showVideopageTutorial);
    } else if (location.location.pathname.includes('/cme')) {
      setShowCmepageTutorial(!showCmepageTutorial);
    } else setShowHomepageTutorial(!showHomepageTutorial);
  };

  useEffect(() => {
    const setFeatureLockUser = () => {
      return setFeaturePermission('sidebar');
    };

    if (setFeatureLockUser()) {
      setLockUser(true);
    }
  }, [loggedInUser, account, setFeaturePermission]);

  const ClickEmptySpace = () => {
    sidebarUIStore.setShow(false);
  };

  return (
    <>
      <HomeTutorial isTutorialOpen={showHomepageTutorial} setIsTourOpen={setShowHomepageTutorial} />
      <VideoTutorial isTutorialOpen={showVideopageTutorial} setIsTourOpen={setShowVideopageTutorial} />
      {/* <CmeTutorial isTutorialOpen={showCmepageTutorial} setIsTourOpen={setShowCmepageTutorial} /> */}
      <Badge
        variant="link"
        // id="open-mobile-sidebar"
        // data-testid="open-mobile-sidebar"
        // className="a_openMobileSidebarButton mr-2"
        ref={target}
        style={{padding: '10px', cursor: 'pointer'}}
        onClick={() => sidebarUIStore.setShow(!show)}
      >
        <i className="fas fa-bars" style={{color: 'white', fontSize: '20px'}} />
      </Badge>
      <Overlay target={target.current} show={show} placement="bottom">
        {({placement, arrowProps, show: _show, popper, ...props}) => (
          <>
            <OuterToggleSideBar onClick={ClickEmptySpace} />
            <StyledDiv {...props}>
              <div className="row flex-column h-100">
                <Nav.Item>
                  <Nav.Link exact as={NavLink} to="/" id="sidebar_home" activeClassName="active">
                    <i className="fas fa-home" />
                    <span className="collapseText">Home</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link data-tut="hometutorial__browse_mobile">
                    <BrowseSidebar />
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="under-menu">
                  <Nav.Link exact as={NavLink} to="/browse/specialty" id="sidebar_specialty" activeClassName="active">
                    <i className="fas fa-user-md" />
                    <span className="collapseText">Specialty</span>
                  </Nav.Link>
                </Nav.Item>
                {/* <Nav.Item className="under-menu">
                  <Nav.Link exact as={NavLink} to="/conferences" id="sidebar_conferences" activeClassName="active">
                    <i className="fas fa-desktop-alt" />
                    <span className="collapseText">Conferences</span>
                  </Nav.Link>
                </Nav.Item> */}
                {account?.access?.content_based ? (
                  <>
                    <Nav.Item>
                      <Nav.Link as={NavLink} to="/purchased" id="sidebar_purchases" activeClassName="active">
                        <i className="fas fa-star" />
                        <span className="collapseText">Purchased</span>
                      </Nav.Link>
                    </Nav.Item>
                  </>
                ) : (
                  ''
                )}

                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    id="Bookmark"
                    to="/bookmarks"
                    activeClassName="active"
                    className={lockUser && 'lock'}
                    disabled={lockUser}
                    data-tut="hometutorial__bookmark_mobile"
                  >
                    <i className="fas fa-bookmark" />
                    <i className="fas fa-bookmark-solid" />
                    {!lockUser ? (
                      <span className="collapseText">Bookmark</span>
                    ) : (
                      <span className="collapseText lock">
                        Bookmark
                        <i className="fas fa-lock-alt lock-icon" />
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/cme"
                    id="sidebar_CME"
                    activeClassName="active"
                    data-tut="hometutorial__cme_mobile"
                    className={!loggedInUser && 'lock'}
                    disabled={!loggedInUser}
                  >
                    <i className="fas fa-certificate" />
                    {loggedInUser ? (
                      <span className="collapseText">My CME</span>
                    ) : (
                      <span className="collapseText lock">
                        My CME
                        <i className="fas fa-lock-alt lock-icon" />
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>

                {account?.access?.certificate && process.env.REACT_APP_QUIZ_CERTIFICATE === 'true' ? (
                  <Nav.Item>
                    <Nav.Link
                      exact
                      as={NavLink}
                      to="/certificate"
                      id=""
                      activeClassName="active"
                      data-tip="Certificate"
                    >
                      <i className="fas fa-graduation-cap-regular" />
                      <span className="collapseText">Certificate</span>
                    </Nav.Link>
                  </Nav.Item>
                ) : (
                  ''
                )}

                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/playlist"
                    id="sidebar_playlist"
                    activeClassName="active"
                    data-tut="hometutorial__playlist_mobile"
                    className={lockUser && 'lock'}
                    disabled={lockUser}
                  >
                    <i className="fas fa-list-ul" />
                    {!lockUser ? (
                      <span className="collapseText">Playlists</span>
                    ) : (
                      <span className="collapseText lock">
                        Playlists
                        <i className="fas fa-lock-alt lock-icon" />
                      </span>
                    )}
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/profile/upload_video"
                    id="sidebar_upload"
                    data-tip="Dashboard"
                    activeClassName="active"
                  >
                    <img src={Videos} className="myVideo" alt="Video" />
                    <span className="collapseText myVideoText">Upload Videos</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/profile/your_videos"
                    id="sidebar_yourVideo"
                    data-tip="Dashboard"
                    activeClassName="active"
                  >
                    <img src={MyVideos} alt="Video" className="myVideo" />
                    <span className="collapseText myVideoText">My Videos</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/profile/messages"
                    id="sidebar_messages"
                    data-tip="Dashboard"
                    activeClassName="active"
                  >
                    <span>
                      <i className="far fa-envelope" />
                      <span className={`${unreadMessage?.length ? 'msgStatus' : ''}`} />
                    </span>
                    <span className="collapseText">Messages</span>
                  </Nav.Link>
                </Nav.Item>
                {loggedInUser?.role === 'admin' && (
                  <>
                    <Nav.Item>
                      <Nav.Link
                        exact
                        as={NavLink}
                        to="/admin_dashboard"
                        id="sidebar_dashboard"
                        activeClassName="active"
                        data-tut="hometutorial__dashboard_mobile"
                        className={lockUser && 'lock'}
                        disabled={lockUser}
                      >
                        <i className="fas fa-chalkboard-teacher" />
                        {!lockUser ? (
                          <span className="collapseText">Dashboard</span>
                        ) : (
                          <span className="collapseText lock">
                            DashBoard
                            <i className="fas fa-lock-alt lock-icon" />
                          </span>
                        )}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link exact as={NavLink} to="/admin" id="sidebar_admin" activeClassName="active">
                        <i className="fas fa-tools" />
                        <span className="collapseText">Admin</span>
                      </Nav.Link>
                    </Nav.Item>
                  </>
                )}
                <Nav.Item>
                  <Nav.Link
                    exact
                    as={NavLink}
                    to="/catalog/videos"
                    id="sidebar_catalog"
                    data-tip="Catalog"
                    activeClassName="active"
                  >
                    <i className="fas fa-book" />
                    <span className="collapseText">Catalog</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link onClick={ShowTutorial} id="sidebar_tutorial" data-tip="Tutorial" activeClassName="active">
                    <i className="fas fa-chalkboard-teacher" />
                    <span className="collapseText">Tutorial</span>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    href="https://www.giblib.com/institutions/resources"
                    target="_blank"
                    id="sidebar_resources"
                    data-tip="Resources"
                    activeClassName="active"
                  >
                    <i className="fas fa-handshake" />
                    <span className="collapseText">Resources</span>
                  </Nav.Link>
                </Nav.Item>
                <div className="mobile-login pt-4 pb-2">
                  {!loggedInUser?.id ? (
                    <Button id="login-button" onClick={() => location.push('/login')}>
                      Login
                    </Button>
                  ) : null}
                </div>
                <div className="bottom-sidebar">
                  <div className="links">
                    <div className="tos">
                      <LinkText>
                        <a href="https://www.giblib.com/support/terms-of-service" target="_blank" rel="noreferrer">
                          Terms of Services
                        </a>
                      </LinkText>
                      <LinkText>
                        <a href="https://www.giblib.com/support/privacy-policy" target="_blank" rel="noreferrer">
                          Privacy Policy
                        </a>
                      </LinkText>
                    </div>
                  </div>
                  <div className="links-tablet">
                    <LinkText>
                      <a href="https://www.giblib.com/support/terms-of-service" target="_blank" rel="noreferrer">
                        Terms of Services
                      </a>
                    </LinkText>
                    <LinkText>
                      <a href="https://www.giblib.com/support/privacy-policy" target="_blank" rel="noreferrer">
                        Privacy Policy
                      </a>
                    </LinkText>
                  </div>
                  {/* <div className="social-links">
                    <a href="https://www.facebook.com/thegiblibapp/" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://x.com/theGIBLIBapp"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on X"
                    >
                      <svg
                        className="svg-inline--fa x-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                      >
                        <path
                          fill="currentColor"
                          d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                        />
                      </svg>
                    </a>
                    <a href="https://www.youtube.com/channel/UCPpRfYLhUU2gi3B2P8cdt0Q" target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-youtube" />
                    </a>
                  </div> */}
                </div>
              </div>
            </StyledDiv>
          </>
        )}
      </Overlay>
    </>
  );
});

export default MobileSidebar;
